import { render, staticRenderFns } from "./Chevron.vue?vue&type=template&id=a9923918&scoped=true&lang=pug&"
import script from "./Chevron.vue?vue&type=script&lang=ts&"
export * from "./Chevron.vue?vue&type=script&lang=ts&"
import style0 from "./Chevron.vue?vue&type=style&index=0&id=a9923918&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9923918",
  null
  
)

export default component.exports